import {
  ACTION_ARGS,
  CONTAINER_ARGS,
  MENU_ARGS,
  pickArgs,
} from '../../../../../utils/spds/metadata';
import { fn, hash } from '@ember/helper';
import Menu from '../../../core/menu/base.gjs';
import MenuItem from '../../../core/menu/item.gjs';
import Super from '../../../core/menu/parent.gjs';

const METADATA = {
  component: 'Spds::Action::Button::Filter::Menu',
  description: 'Menu component for filter buttons',
  meta: {
    ...pickArgs(CONTAINER_ARGS, ['fitContent']).meta,
    ...pickArgs(MENU_ARGS, ['menuAnchorElement', 'menuAnchorOffset', 'menuOpen']).meta,
    onSelect: {
      ...ACTION_ARGS.meta.onClick,
      description: 'Action triggered when a menu item is selected',
    },
  },
  name: 'Filter Menu',
};

export default class SpdsActionButtonFilterMenu extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-action-button-filter-menu';
  componentName = 'Spds::Action::Button::Filter::Menu';

  <template>
    <Menu
      @anchorElement={{@anchorElement}}
      @anchorOffset={{@anchorOffset}}
      @fitContent={{@fitContent}}
      @id={{this.id}}
      @open={{@open}}
      class={{this.classes}}
      data-test-spds-action-button-filter-menu
      {{this.validateArguments}}
      ...attributes
    >
      {{yield
        (hash
          item=(component
            MenuItem
            onClick=@onSelect
            registerComponent=(fn this.registerItem false)
            unregisterComponent=this.unregisterItem
          )
        )
      }}
    </Menu>
  </template>
}

export const ACTION_BUTTON_FILTER_MENU_METADATA = SpdsActionButtonFilterMenu.metadata;
